import { FC } from 'react'
import useCustomLocation  from '../Hooks/useCustomLocation';
const Track: FC = () => {  
    useCustomLocation();
    return (
       <></>
    );
}
export default Track;